export default "6881aee9e251138c.svg"